export const HEADER = 'header';
export const FOOTER = 'footer';
export const MODAL = 'modal';
